module.exports = __webpack_public_path__ + "img/26.44b19f99.png";